import { AST } from '@handlebars/parser';
import { isMustacheStatement } from 'modules/handlebars/domain/statement/utils';
import { isNull } from 'utils/tsHelpers';

export const getMustacheStatementFromStatement = (
  statement: AST.Statement | null,
): AST.MustacheStatement | null =>
  !isNull(statement) && isMustacheStatement(statement) ? statement : null;
